module.exports = __webpack_public_path__ + "static/img/merlin.a8e79c2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/merlin.png
// module id = evhT
// module chunks = 0